import React from 'react';
var MapManagerContext = React.createContext({
    mapImage: '',
    leftUpperCorner: [],
    rightLowerCorner: [],
    scale: 0,
    selectedPoints: []
});
export var MapManagerProvider = MapManagerContext.Provider;
export var MapManagerConsumer = MapManagerContext.Consumer;
export default MapManagerContext;
//# sourceMappingURL=map-manager-context.js.map